import { render, staticRenderFns } from "./AttendanceSampleUpdate.vue?vue&type=template&id=684b6047&scoped=true"
import script from "./AttendanceSampleUpdate.vue?vue&type=script&lang=js"
export * from "./AttendanceSampleUpdate.vue?vue&type=script&lang=js"
import style0 from "./AttendanceSampleUpdate.vue?vue&type=style&index=0&id=684b6047&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684b6047",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684b6047')) {
      api.createRecord('684b6047', component.options)
    } else {
      api.reload('684b6047', component.options)
    }
    module.hot.accept("./AttendanceSampleUpdate.vue?vue&type=template&id=684b6047&scoped=true", function () {
      api.rerender('684b6047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/AttendanceSampleUpdate.vue"
export default component.exports